import React from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';

import { isAdmin } from '../../../utils/request';

import { salesRep, admin } from './utils/getActions';

const Actions = ({ order, status, fetchOrders }) => {
  const getActions = () => {
    if (isAdmin) return admin;
    return salesRep;
  };

  return (
    <>
      {_.get(getActions(), _.toUpper(status), []).map(Action => (
        <Action status={status} orderData={order} fetchOrders={fetchOrders} />
      ))}
    </>
  );
};

Actions.propTypes = {
  order: PropTypes.shape({}).isRequired,
  status: PropTypes.string.isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default Actions;
